// extracted by mini-css-extract-plugin
module.exports = {"paging":"Slider-module--paging--VmQgS","pagingBackground":"Slider-module--pagingBackground--37aYW","pagingProgress":"Slider-module--pagingProgress--3sEhB"};